import { SVGProps } from "react";

export const EditDetailsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.47 0.530032C11.1301 0.19063 10.6694 0 10.189 0C9.70864 0 9.24792 0.19063 8.908 0.530032L0 9.43803V12H2.562L11.47 3.09203C11.8093 2.75204 11.9998 2.29135 11.9998 1.81103C11.9998 1.33072 11.8093 0.870019 11.47 0.530032V0.530032ZM2.15 11H1V9.85003L7.655 3.20003L8.805 4.35003L2.15 11ZM10.763 2.38503L9.5095 3.63853L8.362 2.48853L9.615 1.23703C9.7675 1.08453 9.97433 0.998859 10.19 0.998859C10.4057 0.998859 10.6125 1.08453 10.765 1.23703C10.9175 1.38953 11.0032 1.59636 11.0032 1.81203C11.0032 2.0277 10.9175 2.23453 10.765 2.38703L10.763 2.38503Z"
      fill="#706A85"
    />
  </svg>
);
